/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';

import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import { useLazyQuery } from '@apollo/client';
import getTrialBalance from '../../graphql/query/getTrialBalance';
import _ from 'lodash';
import {
  moneyFormatEmpty,
  simpleDateFormatterData,
} from '../../Shared/colorFormat';
import { BalanceReportPrint } from '../../print/BalanceReportPrint';
import { BudgetReportPrint } from '../../print/BudgetReportPrint';
import { useReactToPrint } from 'react-to-print';
import PrintIcon from '@material-ui/icons/Print';
import { useWindowDimensions } from '../../hooks';
import { useApolloClient } from '@apollo/client';

const full = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
const mizania = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const arbah = [13, 14, 15];
const mainsub = [
  {
    accounts: [1],
    main: 'Assets',
    mainAr: 'الاصول',
    sub: 'Cash',
    subAr: 'الاموال الجاهزة',
  },
  {
    accounts: [2, 3, 4],
    main: 'Assets',
    mainAr: 'الاصول',
    sub: 'Current Assets',
    subAr: 'الاصول المتداولة',
  },
  {
    accounts: [5, 6],
    main: 'Assets',
    mainAr: 'الاصول',
    sub: 'Fixed Assets',
    subAr: 'الاصول الثابتة',
  },
  {
    accounts: [7, 8],
    main: 'Liabilities',
    mainAr: 'الالتزامات',
    sub: 'Liabilities',
    subAr: 'الخصوم',
  },
  {
    accounts: [9],
    main: 'Liabilities',
    mainAr: 'الالتزامات',
    sub: 'Long-term Liabilities',
    subAr: 'التزامات طويلة الأجل',
  },
  {
    accounts: [10, 11, 12],
    main: 'Equity',
    mainAr: 'حقوق الملكية',
    sub: 'Equity',
    subAr: 'حقوق الملكية',
  },
  {
    accounts: [13],
    main: 'Income Statement',
    mainAr: 'قائمة الدخل',
    sub: 'Income',
    subAr: 'الإيرادات',
  },
  {
    accounts: [14],
    main: 'Income Statement',
    mainAr: 'قائمة الدخل',
    sub: 'Cost of Sales',
    subAr: 'تكلفة المبيعات',
  },
  {
    accounts: [15],
    main: 'Income Statement',
    mainAr: 'قائمة الدخل',
    sub: 'Expenses',
    subAr: 'المصروفات',
  },
];

export const renderAccountCell = (d: any, xs: any, p = 10) => (
  <Grid item xs={xs}>
    <Typography style={{ padding: p }}>{d}</Typography>
  </Grid>
);
export const renderAccountCellbalance = (d: any, xs: any, p = 10) => (
  <Grid item xs={xs}>
    <Typography style={{ padding: p, fontWeight: 'bold' }}>{d}</Typography>
  </Grid>
);
export const renderAccountHeaderCell = (d: any, xs: any, p = 10) => (
  <Grid item xs={xs}>
    <Typography color="secondary" style={{ padding: p, fontWeight: 'bold' }}>
      {d}
    </Typography>
  </Grid>
);

export const renderAccount = ({ pacc, isRTL, p = 10 }: any) => {
  const { accounts } = pacc;
  return (
    <Box style={{ backgroundColor: '#eee' }}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Box style={{ backgroundColor: '#fff' }}>
            <Grid container spacing={0}>
              {accounts.map((acc: any) => {
                const {
                  accCode,
                  accName,
                  accNameAr,
                  credit,
                  debit,
                  main,
                  sub,
                  rc,
                  rd,
                } = acc;
                const name = isRTL ? accNameAr : accName;
                return (
                  <>
                    <Grid item xs={12}>
                      <Divider></Divider>
                    </Grid>
                    {renderAccountCell(accCode, 1, p)}
                    {renderAccountCell(main, 2, p)}
                    {renderAccountCell(sub, 2, p)}
                    {renderAccountCell(name, 2, p)}
                    {renderAccountCell(moneyFormatEmpty(debit), 1, p)}
                    {renderAccountCell(moneyFormatEmpty(credit), 1, p)}
                    {renderAccountCellbalance(moneyFormatEmpty(rd), 1, p)}
                    {renderAccountCellbalance(moneyFormatEmpty(rc), 1, p)}
                  </>
                );
              })}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default function BudgetReport({
  isRTL,
  words,
  start,
  end,
  theme,
  company,
  drawerWidth,
}: any) {
  const [parentslist, setParentsList] = useState([]);
  const [pars, setPars] = useState(full);
  const [totals, setTotals] = useState(null);
  const [profit, setProfit] = useState<any>(null);
  const [report, setReport] = useState<any>('tb');

  const [isTime, setIsTime] = useState(true);
  const { width } = useWindowDimensions();

  // Budget report monthly data
  const [budgetData, setBudgetData] = useState<any>(null);
  const [budgetLoading, setBudgetLoading] = useState(false);
  const client = useApolloClient();

  const [getTB, tbData]: any = useLazyQuery(getTrialBalance, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    const dd = tbData?.data?.['getTrialBalance']?.data;
    if (dd) {
      const accs = JSON.parse(dd);

      const faccs = accs.filter(
        (acc: any) =>
          (acc?.credit !== 0 || acc?.debit !== 0) &&
          pars.includes(acc.parentcode),
      );
      const rfaccount = faccs.map((fa: any) => {
        const { credit, debit, parentcode } = fa;
        const raseed = debit - credit;
        const pacc = mainsub?.filter((item: any) =>
          item?.accounts?.includes(parentcode),
        )?.[0];
        const main = isRTL ? pacc?.mainAr : pacc?.main;
        const sub = isRTL ? pacc?.subAr : pacc?.sub;
        let rc = 0;
        let rd = 0;
        if (raseed > 0) {
          rd = raseed;
        } else {
          rc = -raseed;
        }
        return {
          ...fa,
          main,
          sub,
          rd,
          rc,
        };
      });

      const profitaccounts = accs.filter(
        (acc: any) =>
          (acc?.credit !== 0 || acc?.debit !== 0) &&
          arbah.includes(acc.parentcode),
      );
      const rprofitaccounts = profitaccounts.map((fa: any) => {
        const { credit, debit, parentcode } = fa;
        const raseed = debit - credit;
        const pacc = mainsub?.filter((item: any) =>
          item?.accounts?.includes(parentcode),
        )?.[0];
        const main = isRTL ? pacc?.mainAr : pacc?.main;
        const sub = isRTL ? pacc?.subAr : pacc?.sub;
        let rc = 0;
        let rd = 0;
        if (raseed > 0) {
          rd = raseed;
        } else {
          rc = -raseed;
        }
        return {
          ...fa,
          main,
          sub,
          rd,
          rc,
        };
      });

      const profitfilter = rprofitaccounts.filter(
        (rf: any) => rf.rd !== 0 || rf.rc !== 0,
      );

      const profitrd = _.sumBy(profitfilter, 'rd');
      const profitrc = _.sumBy(profitfilter, 'rc');

      const profitrs = profitrd - profitrc;

      setProfit({
        credit: profitrc,
        debit: profitrd,
        raseedd: profitrs > 0 ? profitrs : 0,
        raseedc: profitrs < 0 ? -profitrs : 0,
      });

      // const lfilter = rfaccount.filter((rf: any) => rf.rd !== 0 || rf.rc !== 0);
      const lfilter = rfaccount;

      const allrd = _.sumBy(lfilter, 'rd');
      const allrc = _.sumBy(lfilter, 'rc');
      const allrsd = allrd - allrc;

      const bsrd = allrd + profitrd;
      const bsrc = allrc + profitrc;
      const bsrsd = bsrd - bsrc;

      const graseed = report === 'bs' ? bsrsd : allrsd;

      setTotals({
        credit: report === 'bs' ? bsrc : allrc,
        debit: report === 'bs' ? bsrd : allrd,
        raseedd: graseed > 0 ? graseed : 0,
        raseedc: graseed < 0 ? -graseed : 0,
      });

      const gaccs = _(lfilter)
        .groupBy('parentcode')
        .map((array, key) => ({
          code: Number(key),
          parent: array[0]?.parent,
          parentAr: array[0]?.parentAr,
          credit: _.sumBy(array, 'credit'),
          debit: _.sumBy(array, 'debit'),
          accounts: array,
        }))
        .orderBy('code')
        .value();

      const rfparent = gaccs.map((fa: any) => {
        const { credit, debit } = fa;
        const raseed = debit - credit;
        let rcredit = 0;
        let rdebit = 0;
        if (raseed > 0) {
          rdebit = raseed;
        } else {
          rcredit = -raseed;
        }
        return {
          ...fa,
          rdebit,
          rcredit,
        };
      });

      setParentsList(rfparent);
    }
  }, [tbData, pars]);

  useEffect(() => {
    const variables = isTime ? { start, end } : {};
    getTB({ variables });
  }, [start, end, isTime]);

  // Helper: get months between start and end
  const getMonthsInRange = (s: Date, e: Date) => {
    const months: { start: Date; end: Date; label: string; labelAr: string }[] =
      [];
    const monthNamesEn = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const monthNamesAr = [
      'يناير',
      'فبراير',
      'مارس',
      'أبريل',
      'مايو',
      'يونيو',
      'يوليو',
      'أغسطس',
      'سبتمبر',
      'أكتوبر',
      'نوفمبر',
      'ديسمبر',
    ];
    const sd = new Date(s);
    const ed = new Date(e);
    let cur = new Date(sd.getFullYear(), sd.getMonth(), 1);
    while (cur <= ed) {
      const mStart = new Date(cur);
      const mEnd = new Date(
        cur.getFullYear(),
        cur.getMonth() + 1,
        0,
        23,
        59,
        59,
      );
      months.push({
        start: mStart,
        end: mEnd,
        label: `${monthNamesEn[cur.getMonth()]} ${cur.getFullYear()}`,
        labelAr: `${monthNamesAr[cur.getMonth()]} ${cur.getFullYear()}`,
      });
      cur = new Date(cur.getFullYear(), cur.getMonth() + 1, 1);
    }
    return months;
  };

  // Fetch monthly data for budget report
  useEffect(() => {
    if (report !== 'budget' || !start || !end || !isTime) {
      return;
    }
    const fetchMonthlyData = async () => {
      setBudgetLoading(true);
      try {
        const months = getMonthsInRange(start, end);
        const monthlyResults = await Promise.all(
          months.map(async (m) => {
            const res = await client.query({
              query: getTrialBalance,
              variables: { start: m.start, end: m.end },
              fetchPolicy: 'network-only',
            });
            const dd = res?.data?.getTrialBalance?.data;
            if (dd) {
              return { ...m, accounts: JSON.parse(dd) };
            }
            return { ...m, accounts: [] };
          }),
        );

        // Build structured data: for each account, collect monthly values
        const revenueMap: any = {}; // { accCode: { name, nameAr, months: [credit,...], total } }
        const costMap: any = {};
        const expenseMap: any = {};

        monthlyResults.forEach((mr, mi) => {
          mr.accounts.forEach((acc: any) => {
            if (acc.parentcode === 13) {
              // Revenue
              if (!revenueMap[acc.accCode]) {
                revenueMap[acc.accCode] = {
                  name: acc.accName,
                  nameAr: acc.accNameAr,
                  months: new Array(monthlyResults.length).fill(0),
                  total: 0,
                };
              }
              revenueMap[acc.accCode].months[mi] = acc.credit - acc.debit;
              revenueMap[acc.accCode].total += acc.credit - acc.debit;
            } else if (acc.parentcode === 14) {
              // Cost of Sales
              if (!costMap[acc.accCode]) {
                costMap[acc.accCode] = {
                  name: acc.accName,
                  nameAr: acc.accNameAr,
                  months: new Array(monthlyResults.length).fill(0),
                  total: 0,
                };
              }
              costMap[acc.accCode].months[mi] = acc.debit - acc.credit;
              costMap[acc.accCode].total += acc.debit - acc.credit;
            } else if (acc.parentcode === 15) {
              // Expenses
              if (!expenseMap[acc.accCode]) {
                expenseMap[acc.accCode] = {
                  name: acc.accName,
                  nameAr: acc.accNameAr,
                  months: new Array(monthlyResults.length).fill(0),
                  total: 0,
                };
              }
              expenseMap[acc.accCode].months[mi] = acc.debit - acc.credit;
              expenseMap[acc.accCode].total += acc.debit - acc.credit;
            }
          });
        });

        // Calculate monthly totals
        const numMonths = monthlyResults.length;
        const revenueTotals = new Array(numMonths).fill(0);
        const costTotals = new Array(numMonths).fill(0);
        const expenseTotals = new Array(numMonths).fill(0);

        Object.values(revenueMap).forEach((acc: any) => {
          acc.months.forEach((v: number, i: number) => {
            revenueTotals[i] += v;
          });
        });
        Object.values(costMap).forEach((acc: any) => {
          acc.months.forEach((v: number, i: number) => {
            costTotals[i] += v;
          });
        });
        Object.values(expenseMap).forEach((acc: any) => {
          acc.months.forEach((v: number, i: number) => {
            expenseTotals[i] += v;
          });
        });

        const grossProfitMonths = revenueTotals.map(
          (r, i) => r - costTotals[i],
        );
        const netIncomeMonths = grossProfitMonths.map(
          (g, i) => g - expenseTotals[i],
        );

        setBudgetData({
          months: monthlyResults.map((m) => ({
            label: m.label,
            labelAr: m.labelAr,
          })),
          revenue: Object.values(revenueMap).filter((a: any) => a.total !== 0),
          cost: Object.values(costMap).filter((a: any) => a.total !== 0),
          expenses: Object.values(expenseMap).filter((a: any) => a.total !== 0),
          revenueTotals,
          costTotals,
          expenseTotals,
          grossProfitMonths,
          netIncomeMonths,
          totalRevenue: _.sum(revenueTotals),
          totalCost: _.sum(costTotals),
          totalExpenses: _.sum(expenseTotals),
          totalGrossProfit: _.sum(grossProfitMonths),
          totalNetIncome: _.sum(netIncomeMonths),
        });
      } catch (err) {
        console.log('Budget fetch error', err);
      }
      setBudgetLoading(false);
    };
    fetchMonthlyData();
  }, [report, start, end, isTime]);

  const componentRef: any = useRef();
  const documentTitle =
    report === 'tb'
      ? isRTL
        ? 'ميزان المراجعة'
        : 'Trial Sheet'
      : report === 'is'
        ? isRTL
          ? 'قائمة الدخل'
          : 'Income Statment'
        : report === 'bs'
          ? isRTL
            ? 'الميزانية العمومية'
            : 'Balance Sheet'
          : report === 'budget'
            ? isRTL
              ? 'تقرير الميزانية'
              : 'Budget Report'
            : '';
  const print = useReactToPrint({
    content: () => componentRef.current,
    documentTitle,
    removeAfterPrint: true,
  });

  return (
    <>
      <Box
        p={1}
        display="flex"
        style={{
          position: 'absolute',
          top: 40,
          left: 200,
          flexGrow: 1,
        }}
      >
        <Box>
          <Box display="flex">
            <Box style={{ padding: 7 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    style={{ padding: 7 }}
                    checked={isTime}
                    onChange={() => {
                      setIsTime(!isTime);
                    }}
                    color="primary"
                  />
                }
                label={
                  <Typography
                    style={{
                      color: theme.palette.primary.main,
                      fontWeight: 'bold',
                    }}
                  >
                    {isRTL ? 'تفعيل التاريخ' : 'Activate Date'}
                  </Typography>
                }
                style={{ fontSize: 14 }}
              />
            </Box>
          </Box>
        </Box>
        <Box style={{ marginLeft: 100, marginRight: 100 }}>
          <Button
            color="primary"
            variant={report === 'tb' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('tb');
              setPars(full);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'ميزان المراجعة' : 'Trial Sheet'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={report === 'is' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('is');
              setPars(arbah);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'قائمة الدخل' : 'Income Statment'}
            </Typography>
          </Button>
          <Button
            color="primary"
            variant={report === 'bs' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('bs');
              setPars(mizania);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'الميزانية العمومية' : 'Balance Sheet'}
            </Typography>
          </Button>
          <Button
            color="secondary"
            variant={report === 'budget' ? 'contained' : 'outlined'}
            onClick={() => {
              setReport('budget');
              setPars(arbah);
            }}
            style={{ margin: 10, padding: 5, minWidth: 150 }}
          >
            <Typography style={{ fontWeight: 'bold' }}>
              {isRTL ? 'تقرير الميزانية' : 'Budget Report'}
            </Typography>
          </Button>
        </Box>
        <Box
          style={{
            position: 'absolute',
            left: isRTL ? 50 : undefined,
            right: isRTL ? undefined : 50,
            top: 15,
            zIndex: 112,
          }}
        >
          <IconButton onClick={print} title="Print Report" size="medium">
            <PrintIcon />
          </IconButton>
        </Box>
      </Box>
      <Box
        style={{
          width: width - 50,
          borderRadius: 25,
          overflow: 'auto',
          padding: 25,
        }}
      >
        {report === 'budget' ? (
          <Box style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
            <Box style={{ textAlign: 'center', marginBottom: 20 }}>
              <Typography
                variant="h5"
                style={{ fontWeight: 'bold', marginBottom: 5 }}
              >
                {isRTL ? 'تقرير الميزانية' : 'Budget Report'}
              </Typography>
              {start && end && isTime && (
                <Typography variant="body2" style={{ color: '#666' }}>
                  {simpleDateFormatterData(start)} -{' '}
                  {simpleDateFormatterData(end)}
                </Typography>
              )}
            </Box>
            {budgetLoading ? (
              <Box style={{ textAlign: 'center', padding: 50 }}>
                <Typography>
                  {isRTL ? 'جاري التحميل...' : 'Loading...'}
                </Typography>
              </Box>
            ) : !budgetData || !isTime ? (
              <Box style={{ textAlign: 'center', padding: 50 }}>
                <Typography style={{ color: '#999' }}>
                  {isRTL
                    ? 'يرجى تفعيل التاريخ وتحديد الفترة'
                    : 'Please activate dates and select a period'}
                </Typography>
              </Box>
            ) : (
              <Box style={{ overflow: 'auto' }}>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    minWidth: budgetData.months.length * 120 + 200,
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: '#4F5EB3', color: '#fff' }}>
                      <th
                        style={{
                          padding: 8,
                          textAlign: isRTL ? 'right' : 'left',
                          border: '1px solid #ddd',
                          minWidth: 180,
                        }}
                      >
                        {isRTL ? 'البيان' : 'Description'}
                      </th>
                      {budgetData.months.map((m: any, i: number) => (
                        <th
                          key={i}
                          style={{
                            padding: 8,
                            textAlign: 'center',
                            border: '1px solid #ddd',
                            minWidth: 110,
                          }}
                        >
                          {isRTL ? m.labelAr : m.label}
                        </th>
                      ))}
                      <th
                        style={{
                          padding: 8,
                          textAlign: 'center',
                          border: '1px solid #ddd',
                          minWidth: 110,
                          backgroundColor: '#3a4a9f',
                        }}
                      >
                        {isRTL ? 'الإجمالي' : 'Total'}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Revenue Section */}
                    <tr>
                      <td
                        colSpan={budgetData.months.length + 2}
                        style={{
                          padding: 8,
                          backgroundColor: '#E8F0FE',
                          fontWeight: 'bold',
                          fontSize: 13,
                          border: '1px solid #ddd',
                          textAlign: isRTL ? 'right' : 'left',
                        }}
                      >
                        {isRTL ? 'الإيرادات' : 'Revenues'}
                      </td>
                    </tr>
                    {budgetData.revenue.map((acc: any, i: number) => (
                      <tr key={`rev-${i}`} style={{ fontSize: 12 }}>
                        <td style={{ padding: 8, border: '1px solid #ddd' }}>
                          {isRTL ? acc.nameAr : acc.name}
                        </td>
                        {acc.months.map((v: number, mi: number) => (
                          <td
                            key={mi}
                            style={{
                              padding: 8,
                              textAlign: 'right',
                              border: '1px solid #ddd',
                            }}
                          >
                            {moneyFormatEmpty(v)}
                          </td>
                        ))}
                        <td
                          style={{
                            padding: 8,
                            textAlign: 'right',
                            border: '1px solid #ddd',
                            fontWeight: 'bold',
                          }}
                        >
                          {moneyFormatEmpty(acc.total)}
                        </td>
                      </tr>
                    ))}
                    {/* Total Revenue */}
                    <tr
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#E8F0FE',
                        fontSize: 12,
                      }}
                    >
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>
                        {isRTL ? 'إجمالي الإيرادات' : 'Total Revenue'}
                      </td>
                      {budgetData.revenueTotals.map((v: number, i: number) => (
                        <td
                          key={i}
                          style={{
                            padding: 8,
                            textAlign: 'right',
                            border: '1px solid #ddd',
                          }}
                        >
                          {moneyFormatEmpty(v)}
                        </td>
                      ))}
                      <td
                        style={{
                          padding: 8,
                          textAlign: 'right',
                          border: '1px solid #ddd',
                        }}
                      >
                        {moneyFormatEmpty(budgetData.totalRevenue)}
                      </td>
                    </tr>

                    {/* Cost of Sales Section */}
                    {budgetData.cost.length > 0 && (
                      <>
                        <tr>
                          <td
                            colSpan={budgetData.months.length + 2}
                            style={{
                              padding: 8,
                              backgroundColor: '#FCE4EC',
                              fontWeight: 'bold',
                              fontSize: 13,
                              border: '1px solid #ddd',
                              textAlign: isRTL ? 'right' : 'left',
                            }}
                          >
                            {isRTL ? 'تكلفة المبيعات' : 'Cost of Sales'}
                          </td>
                        </tr>
                        {budgetData.cost.map((acc: any, i: number) => (
                          <tr key={`cost-${i}`} style={{ fontSize: 12 }}>
                            <td
                              style={{ padding: 8, border: '1px solid #ddd' }}
                            >
                              {isRTL ? acc.nameAr : acc.name}
                            </td>
                            {acc.months.map((v: number, mi: number) => (
                              <td
                                key={mi}
                                style={{
                                  padding: 8,
                                  textAlign: 'right',
                                  border: '1px solid #ddd',
                                }}
                              >
                                {moneyFormatEmpty(v)}
                              </td>
                            ))}
                            <td
                              style={{
                                padding: 8,
                                textAlign: 'right',
                                border: '1px solid #ddd',
                                fontWeight: 'bold',
                              }}
                            >
                              {moneyFormatEmpty(acc.total)}
                            </td>
                          </tr>
                        ))}
                        <tr
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#FCE4EC',
                            fontSize: 12,
                          }}
                        >
                          <td style={{ padding: 8, border: '1px solid #ddd' }}>
                            {isRTL
                              ? 'إجمالي تكلفة المبيعات'
                              : 'Total Cost of Sales'}
                          </td>
                          {budgetData.costTotals.map((v: number, i: number) => (
                            <td
                              key={i}
                              style={{
                                padding: 8,
                                textAlign: 'right',
                                border: '1px solid #ddd',
                              }}
                            >
                              {moneyFormatEmpty(v)}
                            </td>
                          ))}
                          <td
                            style={{
                              padding: 8,
                              textAlign: 'right',
                              border: '1px solid #ddd',
                            }}
                          >
                            {moneyFormatEmpty(budgetData.totalCost)}
                          </td>
                        </tr>
                      </>
                    )}

                    {/* Gross Profit */}
                    <tr
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#F0F4F8',
                        fontSize: 12,
                      }}
                    >
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>
                        {isRTL ? 'مجمل الربح' : 'Gross Profit'}
                      </td>
                      {budgetData.grossProfitMonths.map(
                        (v: number, i: number) => (
                          <td
                            key={i}
                            style={{
                              padding: 8,
                              textAlign: 'right',
                              border: '1px solid #ddd',
                              color: v < 0 ? '#f44336' : '#2e7d32',
                            }}
                          >
                            {moneyFormatEmpty(v)}
                          </td>
                        ),
                      )}
                      <td
                        style={{
                          padding: 8,
                          textAlign: 'right',
                          border: '1px solid #ddd',
                          color:
                            budgetData.totalGrossProfit < 0
                              ? '#f44336'
                              : '#2e7d32',
                        }}
                      >
                        {moneyFormatEmpty(budgetData.totalGrossProfit)}
                      </td>
                    </tr>

                    {/* Expenses Section */}
                    <tr>
                      <td
                        colSpan={budgetData.months.length + 2}
                        style={{
                          padding: 8,
                          backgroundColor: '#FFF3E0',
                          fontWeight: 'bold',
                          fontSize: 13,
                          border: '1px solid #ddd',
                          textAlign: isRTL ? 'right' : 'left',
                        }}
                      >
                        {isRTL ? 'المصاريف التشغيلية' : 'Operating Expenses'}
                      </td>
                    </tr>
                    {budgetData.expenses.map((acc: any, i: number) => (
                      <tr key={`exp-${i}`} style={{ fontSize: 12 }}>
                        <td style={{ padding: 8, border: '1px solid #ddd' }}>
                          {isRTL ? acc.nameAr : acc.name}
                        </td>
                        {acc.months.map((v: number, mi: number) => (
                          <td
                            key={mi}
                            style={{
                              padding: 8,
                              textAlign: 'right',
                              border: '1px solid #ddd',
                            }}
                          >
                            {moneyFormatEmpty(v)}
                          </td>
                        ))}
                        <td
                          style={{
                            padding: 8,
                            textAlign: 'right',
                            border: '1px solid #ddd',
                            fontWeight: 'bold',
                          }}
                        >
                          {moneyFormatEmpty(acc.total)}
                        </td>
                      </tr>
                    ))}
                    {/* Total Expenses */}
                    <tr
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#FFF3E0',
                        fontSize: 12,
                      }}
                    >
                      <td style={{ padding: 8, border: '1px solid #ddd' }}>
                        {isRTL
                          ? 'إجمالي المصاريف التشغيلية'
                          : 'Total Operating Expenses'}
                      </td>
                      {budgetData.expenseTotals.map((v: number, i: number) => (
                        <td
                          key={i}
                          style={{
                            padding: 8,
                            textAlign: 'right',
                            border: '1px solid #ddd',
                          }}
                        >
                          {moneyFormatEmpty(v)}
                        </td>
                      ))}
                      <td
                        style={{
                          padding: 8,
                          textAlign: 'right',
                          border: '1px solid #ddd',
                        }}
                      >
                        {moneyFormatEmpty(budgetData.totalExpenses)}
                      </td>
                    </tr>

                    {/* Spacer */}
                    <tr>
                      <td
                        colSpan={budgetData.months.length + 2}
                        style={{ height: 10, border: 'none' }}
                      ></td>
                    </tr>

                    {/* Net Income */}
                    <tr
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#E8F5E9',
                        fontSize: 13,
                      }}
                    >
                      <td style={{ padding: 10, border: '1px solid #ddd' }}>
                        {isRTL ? 'صافي الدخل التشغيلي' : 'Net Operating Income'}
                      </td>
                      {budgetData.netIncomeMonths.map(
                        (v: number, i: number) => (
                          <td
                            key={i}
                            style={{
                              padding: 10,
                              textAlign: 'right',
                              border: '1px solid #ddd',
                              color: v < 0 ? '#f44336' : '#2e7d32',
                            }}
                          >
                            {moneyFormatEmpty(v)}
                          </td>
                        ),
                      )}
                      <td
                        style={{
                          padding: 10,
                          textAlign: 'right',
                          border: '1px solid #ddd',
                          color:
                            budgetData.totalNetIncome < 0
                              ? '#f44336'
                              : '#2e7d32',
                        }}
                      >
                        {moneyFormatEmpty(budgetData.totalNetIncome)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Box>
            )}
          </Box>
        ) : (
          <>
            <Grid container spacing={0}>
              {renderAccountHeaderCell(isRTL ? 'الرقم' : 'No', 1)}
              {renderAccountHeaderCell(isRTL ? 'الرئيسي' : 'Main', 2)}
              {renderAccountHeaderCell(isRTL ? 'الفرعي' : 'Sub', 2)}
              {renderAccountHeaderCell(isRTL ? 'الحساب' : 'Account', 2)}
              {renderAccountHeaderCell(isRTL ? 'مدين' : 'Debit', 1)}
              {renderAccountHeaderCell(isRTL ? 'دائن' : 'Credit', 1)}
              {renderAccountHeaderCell(
                isRTL ? 'رصيد مدين' : 'Debit balance',
                1,
              )}
              {renderAccountHeaderCell(
                isRTL ? 'رصيد دائن' : 'Credit balance',
                1,
              )}
            </Grid>
            {parentslist.map((pacc: any) => {
              return renderAccount({ pacc, isRTL });
            })}
            {report === 'bs' && (
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Divider></Divider>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={8}>
                  <Typography style={{ padding: 10, fontWeight: 'bold' }}>
                    {isRTL ? 'قائمة الدخل' : 'Income Statment'}
                  </Typography>
                </Grid>
                {renderAccountCellbalance(moneyFormatEmpty(profit?.debit), 1)}
                {renderAccountCellbalance(moneyFormatEmpty(profit?.credit), 1)}
                <Grid item xs={12}>
                  <Divider></Divider>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={8}>
                  <Typography
                    color="secondary"
                    style={{ padding: 10, fontWeight: 'bold' }}
                  >
                    {isRTL ? 'صافي ( الربح/الخسارة )' : 'Net Profit / Loss'}
                  </Typography>
                </Grid>
                {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedd), 1)}
                {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedc), 1)}
              </Grid>
            )}

            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Divider></Divider>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={8}></Grid>
              {renderAccountHeaderCell(moneyFormatEmpty(totals?.debit), 1)}
              {renderAccountHeaderCell(moneyFormatEmpty(totals?.credit), 1)}
            </Grid>
            {report === 'is' && (
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Divider></Divider>
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={8}>
                  <Typography
                    color="secondary"
                    style={{ padding: 10, fontWeight: 'bold' }}
                  >
                    {isRTL ? 'صافي ( الربح/الخسارة )' : 'Net Profit / Loss'}
                  </Typography>
                </Grid>
                {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedd), 1)}
                {renderAccountHeaderCell(moneyFormatEmpty(profit?.raseedc), 1)}
              </Grid>
            )}
            <Grid item xs={12}>
              <Box m={6}></Box>
            </Grid>
          </>
        )}
      </Box>
      <Box>
        <div style={{ display: 'none' }}>
          {report === 'budget' ? (
            <BudgetReportPrint
              company={company}
              ref={componentRef}
              isRTL={isRTL}
              start={start}
              end={end}
              documentTitle={documentTitle}
              isTime={isTime}
              budgetData={budgetData}
            />
          ) : (
            <BalanceReportPrint
              company={company}
              parentslist={parentslist}
              report={report}
              ref={componentRef}
              isRTL={isRTL}
              start={start}
              end={end}
              profit={profit}
              totals={totals}
              documentTitle={documentTitle}
              isTime={isTime}
            />
          )}
        </div>
      </Box>
    </>
  );
}
